var map = {
	"./home/en.json": 83571,
	"./home/es.json": 33044,
	"./home/pt.json": 44660,
	"./layouts/default/en.json": 26122,
	"./layouts/default/es.json": 39344,
	"./layouts/default/pt.json": 41258,
	"./pages/claims/en.json": 57510,
	"./pages/claims/es.json": 12000,
	"./pages/claims/pt.json": 62585,
	"./pages/cookies-policy/en.json": 23690,
	"./pages/cookies-policy/es.json": 31112,
	"./pages/cookies-policy/pt.json": 2872,
	"./pages/institutional-information/en.json": 94858,
	"./pages/institutional-information/es.json": 93317,
	"./pages/institutional-information/pt.json": 66324,
	"./pages/news/en.json": 24010,
	"./pages/news/es.json": 68018,
	"./pages/news/pt.json": 85526,
	"./pages/privacidade-policy/en.json": 75631,
	"./pages/privacidade-policy/es.json": 43319,
	"./pages/privacidade-policy/pt.json": 98454,
	"./pages/privacy-policy/en.json": 74831,
	"./pages/privacy-policy/es.json": 91943,
	"./pages/privacy-policy/pt.json": 29879,
	"./pages/profile/en.json": 61634,
	"./pages/profile/es.json": 92370,
	"./pages/profile/pt.json": 34982,
	"./pages/recharge/en.json": 6630,
	"./pages/recharge/es.json": 22773,
	"./pages/recharge/pt.json": 20734,
	"./pages/renting/en.json": 22810,
	"./pages/renting/es.json": 21704,
	"./pages/renting/pt.json": 82016,
	"./pages/routes/en.json": 56346,
	"./pages/routes/es.json": 62042,
	"./pages/routes/pt.json": 69836,
	"./pages/transport-request/en.json": 24795,
	"./pages/transport-request/es.json": 16767,
	"./pages/transport-request/pt.json": 68911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56848;